export default function () {
  let window = 'alteraca-senha-usuario'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Alterar senha',
    width: '400',
    height: '600',
    minHeight: '300px',
    backdrop: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('../components/AlterarSenhaForm'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
